const global = window

inputs.fn.planif = {
    update(input, parent, data, subdata) {
        let icon = ''
        let title = ''
        let text = ''
        const dateNow = new Date()
        dateNow.setHours(0, 0, 0, 0)
        // dateNow.setDate(dateNow.getDate() - 1)
        const priority = parent.find('[data-name=planif_priority]')
        const priorityVal = priority.val()

        // Complete
        if (subdata.complete) {
            icon = 'green'
            title = '<strong>Complété</strong>'
            text = '<strong>Fini</strong> le '
                    + formatDate(subdata.complete)
        }
        // Terminé (forcé)
        else if (data.status == 'terminated') {
            icon = 'greendark'
            title = '<strong>Complété (Forcé par la fin du contrat)</strong>'
            text = '<strong>Fini</strong> (forcé)'
        }
        // État gelé
        else if (priorityVal == -2) {
            icon = 'blue'
            title = '<strong>En attente</strong>'
            text = 'En attente'
        }
        // En retard
        else if (subdata.end && new Date(subdata.end) <= dateNow) {
            icon = 'red'
            title = '<strong>En retard</strong>'
            text = 'Retard <strong>'
                    + formatDate(subdata.end)
                    + '</strong>'
        } else if (dateNow < new Date(subdata.start)) {
            icon = 'violet'
            title = '<strong>À venir</strong>'
            text = 'Début <strong>'
                    + formatDate(subdata.start)
                    + '</strong>'
        } else if (subdata.end) {
            icon = 'yellow'
            title = '<strong>En cours</strong>'
            text = 'Dû <strong>' + formatDate(subdata.end) + '</strong>'
        } else if (subdata.start) {
            icon = 'yellow'
            title = '<strong>En cours</strong>'
            text = 'Dû <strong>' + 'Date non déterminée' + '</strong>'
        } else {
            icon = 'grey'
            title = '<strong>Non planifié</strong>'
            text = 'Non planifié'
        }
        if (subdata.start) {
            title
                    += '<br />Début : <strong>'
                    + formatDate(subdata.start)
                    + '</strong>'
        }
        if (subdata.end) {
            title
                    += '<br />Fin : <strong>'
                    + formatDate(subdata.end)
                    + '</strong>'
        }
        input.attr('title', title)
        input.data('tip-title', title)
        input.find('.info').html(text)
        input
            .find('.ico')
            .data('ico', icon)
            .find('.icon')
            .attr('class', 'icon-' + icon + ' icon icon--24')
        onContentLoad(input)
        BEHAV.apply(parent);
    },
    updateAuto(input, parent, data) {
        inputs.fn.planif.update(input, parent, data, {
            start: parent.find('[data-name=' + data.map.start + ']').val(),
            end: parent.find('[data-name=' + data.map.end + ']').val(),
            complete: parent.find('[data-name=' + data.map.complete + ']:not([disabled])').val(),
        })
    },
}

inputs.types.planif = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.map) {
        if (data.map) {
            parent
                .find(
                    '[data-name='
                            + data.map.start
                            + '],[data-name='
                            + data.map.end
                            + '],[data-name='
                            + data.map.complete
                            + ']',
                )
                .change(function () {
                    inputs.fn.planif.updateAuto(input, parent, data)
                })
            inputs.fn.planif.updateAuto(input, parent, data)
            
            const priority = parent.find('[data-name=planif_priority]')
            priority.change(function () {
                inputs.fn.planif.updateAuto(input, parent, data);
            })
        }
    }
    return data
}
